import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import GlobalNavMenu from "components/GlobalNavMenu";

import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import UserRegistration from './pages/user-registration';
import LandingPageAIExecution from './pages/landing-page-ai-execution-infrastructure';
import CommandCenter from './pages/command-center-ai-execution-interface';
import PricingSimplifiedExecutionPlans from './pages/pricing';
import PaymentSuccessOnboarding from './pages/payment-success-onboarding';
import MissionHistory from './pages/mission-history';
import LeadCommandCenter from './pages/lead-command-center';
import Operations from './pages/operations';
import OnboardingPage from './pages/onboarding';
import WorkspacePage from './pages/workspace';
import JoinPage from './pages/join';
import DeliveryCommandCenter from './pages/delivery-command-center';
import PrivacyPage from './pages/privacy';
import ContactPage from './pages/contact';
import AffiliatePage from './pages/affiliate-program';
import AffiliateApplyPage from './pages/affiliate-apply';
import AffiliateDashboard from './pages/affiliate-dashboard';
import TermsPage from './pages/terms';
import UserProfileSettings from './pages/user-profile-settings';
import RequireAuth from './components/guards/RequireAuth';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <GlobalNavMenu />
        <RouterRoutes>
          <Route path="/" element={<LandingPageAIExecution />} />
          <Route path="/landing-page-ai-execution-infrastructure" element={<LandingPageAIExecution />} />
          <Route path="/command-center-ai-execution-interface" element={<RequireAuth><CommandCenter /></RequireAuth>} />
          <Route path="/pricing" element={<PricingSimplifiedExecutionPlans />} />
          <Route path="/user-login" element={<UserLogin />} />
          <Route path="/user-registration" element={<UserRegistration />} />
          <Route path="/payment-success-onboarding" element={<RequireAuth><PaymentSuccessOnboarding /></RequireAuth>} />
          <Route path="/mission-history" element={<RequireAuth><MissionHistory /></RequireAuth>} />
          <Route path="/lead-command-center" element={<RequireAuth><LeadCommandCenter /></RequireAuth>} />
          <Route path="/operations" element={<RequireAuth><Operations /></RequireAuth>} />
          <Route path="/delivery-command-center" element={<RequireAuth><DeliveryCommandCenter /></RequireAuth>} />
          <Route path="/onboarding" element={<RequireAuth><OnboardingPage /></RequireAuth>} />
          <Route path="/workspace" element={<RequireAuth><WorkspacePage /></RequireAuth>} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/affiliate-program" element={<AffiliatePage />} />
          <Route path="/affiliate-dashboard" element={<RequireAuth><AffiliateDashboard /></RequireAuth>} />
          <Route path="/affiliate-program/apply" element={<AffiliateApplyPage />} />
          <Route path="/user-profile-settings" element={<RequireAuth><UserProfileSettings /></RequireAuth>} />
          <Route path="/debug/ai" element={<Navigate to="/" replace />} />
          <Route path="/debug/ollama" element={<Navigate to="/" replace />} />
          <Route path="/ollama-debug-test-panel" element={<Navigate to="/" replace />} />
          <Route path="/ai-debug-testing-interface" element={<Navigate to="/" replace />} />
          <Route path="/express-server-configuration-setup" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
